module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error/page-not-found.component.css
// module id = ./src/app/components/error/page-not-found.component.css
// module chunks = main